import { render } from "./order-products.vue?vue&type=template&id=071d25de&scoped=true"
import script from "./order-products.vue?vue&type=script&lang=js"
export * from "./order-products.vue?vue&type=script&lang=js"

import "./order-products.vue?vue&type=style&index=0&id=071d25de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071d25de"]])

export default __exports__